import { InputManager } from "../events/InputManager";
import { LayaGL } from "../layagl/LayaGL";
import { PAL } from "../platform/PlatformAdapters";
import { Browser } from "../utils/Browser";
import { Config } from "./../../Config";
import { ILaya } from "./../../ILaya";
var _renderCount = 0;
export class Render {
    static get paused() {
        return Render._paused;
    }
    static set paused(value) {
        var _a, _b, _c;
        if (Render._paused === value)
            return;
        Render._paused = value;
        if (!value) {
            (_a = ILaya.systemTimer) === null || _a === void 0 ? void 0 : _a._markResumed();
            (_b = ILaya.physicsTimer) === null || _b === void 0 ? void 0 : _b._markResumed();
            (_c = ILaya.timer) === null || _c === void 0 ? void 0 : _c._markResumed();
        }
    }
    static __init__() {
        Render.frameInterval = 1000 / Config.FPS;
        let timeId = 0;
        PAL.browser.on("visibilitychange", (visible) => {
            if (!visible)
                timeId = window.setInterval(Render.loop, 1000);
            else if (timeId != 0)
                window.clearInterval(timeId);
        });
        Render.startLoop();
    }
    static startLoop() {
        let lastTime = null;
        let first = true;
        let startTm = 0;
        let leftTime = 0;
        function loop(timestamp) {
            if (timestamp == null || PAL.g !== null)
                timestamp = performance.now();
            let interval = Render.frameInterval;
            if (first) {
                startTm = Math.floor(timestamp / interval) * interval;
                first = false;
            }
            let delta = leftTime + timestamp - lastTime;
            if (delta + 1 >= interval || !Config.fixedFrames) {
                leftTime = Math.min(delta - interval, interval);
                lastTime = timestamp;
                Render.lastFrame = Math.floor((timestamp - startTm) / interval);
                Render.loop(timestamp);
            }
            window.requestAnimationFrame(loop);
        }
        window.requestAnimationFrame(loop);
    }
    static loop(timestamp) {
        _renderCount++;
        if (!Render.forceOnce) {
            if (Render.paused) {
                Render._syncTimersOnPause(timestamp);
                return;
            }
            let shouldUpdate = true;
            if (Render.predicate != null)
                shouldUpdate = Render.predicate(timestamp);
            else {
                switch (Render.throttleMode) {
                    case 1:
                        shouldUpdate = (_renderCount % (ILaya.stage._visible ? 2 : 5) === 0);
                        break;
                    case 2:
                        shouldUpdate = (timestamp - InputManager.lastMouseTime) < 2000 || (_renderCount % (ILaya.stage._visible ? 2 : 5) === 0);
                        break;
                    case 3:
                        shouldUpdate = timestamp - Render.frameStartTime >= 1000;
                        break;
                }
            }
            if (!shouldUpdate)
                return;
        }
        else {
            Render.stepMode = true;
            Render.forceOnce = false;
        }
        Render.frameStartTime = timestamp;
        LayaGL.statAgent.startFrameLogic(timestamp);
        ILaya.stage.render(timestamp);
        LayaGL.statAgent.endFrameLogic(timestamp);
        Render.stepMode = false;
    }
    static vsyncTime() {
        return Render.lastFrame * Render.frameInterval;
    }
    static _syncTimersOnPause(timestamp) {
        var _a, _b, _c;
        (_a = ILaya.systemTimer) === null || _a === void 0 ? void 0 : _a._syncTimestamp(timestamp);
        (_b = ILaya.physicsTimer) === null || _b === void 0 ? void 0 : _b._syncTimestamp(timestamp);
        (_c = ILaya.timer) === null || _c === void 0 ? void 0 : _c._syncTimestamp(timestamp);
    }
    static get canvas() {
        return Browser.mainCanvas.source;
    }
}
Render.frameInterval = 1000 / 60;
Render.lastFrame = 0;
Render.frameStartTime = 0;
Render.throttleMode = 0;
Render.predicate = null;
Render._paused = false;
Render.forceOnce = false;
Render.stepMode = false;
